import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useState } from 'react';
import { BackendFolder } from '@/types/backend';
import FolderTreeView from '@/components/navigation/folder/FolderTreeView';

type MoveApplicationDialogProps = {
  folders: BackendFolder[] | undefined;
  open: boolean;
  onSelect: (folderId: number) => void;
  onClose: () => void;
};

const MoveApplicationDialog: FC<MoveApplicationDialogProps> = (props) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number>(1);

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Select folder to move to</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <FolderTreeView
          folders={props.folders}
          foldersOnly
          onFolderClick={(folder) => setSelectedFolderId(folder.folderId)}
          onFolderDoubleClick={(folder) => props.onSelect(folder.folderId)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={() => props.onSelect(selectedFolderId)} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveApplicationDialog;
